module.exports = __webpack_public_path__ + "static/media/logo_1.e946e5de.png";